// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useLayoutEffect, useRef, useState } from 'react';

export enum ScreenSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export default function useScreenSize(): ScreenSize | undefined {
  const [value, setValue] = useState<ScreenSize>();

  const valueRef = useRef(value);
  valueRef.current = value;

  const f = () => {
    if (window.innerWidth <= 575.98) {
      if (valueRef.current !== ScreenSize.xs) {
        setValue(ScreenSize.xs);
      }
    } else if (window.innerWidth <= 767.98) {
      if (valueRef.current !== ScreenSize.sm) {
        setValue(ScreenSize.sm);
      }
    } else if (window.innerWidth <= 991.98) {
      if (valueRef.current !== ScreenSize.md) {
        setValue(ScreenSize.md);
      }
    } else if (window.innerWidth <= 1199.98) {
      if (valueRef.current !== ScreenSize.lg) {
        setValue(ScreenSize.lg);
      }
    } else if (window.innerWidth > 1199.98) {
      if (valueRef.current !== ScreenSize.xl) {
        setValue(ScreenSize.xl);
      }
    }
  };

  useLayoutEffect(() => {
    f();
    window.addEventListener('resize', f);
    return () => {
      window.removeEventListener('resize', f);
    };
  }, []);

  return value;
}
